import { __decorate } from "tslib";
import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { TooltipSize } from './viedoc-tooltip.js';
let ViedocTooltipContent = class ViedocTooltipContent extends LitElement {
    constructor() {
        super(...arguments);
        this.size = TooltipSize.Medium;
    }
    render() {
        const classNames = classMap({
            'tooltip-content': true,
            [`tooltip-content--${this.size}`]: true,
        });
        return html `
      <div class=${classNames}>
        <slot name="content"></slot>
      </div>
    `;
    }
};
ViedocTooltipContent.styles = [
    css `
      .tooltip-content {
        -webkit-font-smoothing: antialiased;
        box-sizing: border-box;
        font-family: var(--font-family-monument);
        font-size: var(--font-size-2xs);
        line-height: var(--line-height-normal);

        background: var(--color-gray-70);
        color: var(--color-gray-5);
        border-radius: 0.4375rem;
        padding: 0.25rem 0.375rem 0.125rem;
        word-wrap: break-word;
      }

      .tooltip-content--small {
        font-size: var(--font-size-3xs);
        padding: 0.063rem 0.313rem;
        border-radius: 0.375rem;
      }
    `,
];
__decorate([
    property({ type: String })
], ViedocTooltipContent.prototype, "size", void 0);
ViedocTooltipContent = __decorate([
    customElement('viedoc-tooltip-content')
], ViedocTooltipContent);
export { ViedocTooltipContent };
